import { defaultStore } from './store';

export default defaultStore;
